// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Link from "next/link";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Router from "next/router";
import ReactMarkdown from "react-markdown";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as MediaQuery$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as HomeStoreEn$PorterinFeature from "../../../../containers/home/domain/store/HomeStoreEn.mjs";
import * as FooterModuleScss from "../styles/Footer.module.scss";
import * as FooterConfig$PorterinFeature from "../../repo/FooterConfig.mjs";
import * as PageviewStore$PorterinFeature from "../../../../containers/fare-estimate-v1/domain/store/PageviewStore.mjs";
import * as DownloadAppStore$PorterinFeature from "../../../download-app/constants/DownloadAppStore.mjs";
import * as FooterLinksMapper$PorterinFeature from "../../view-model/FooterLinksMapper.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";
import * as FooterDownloadAppCmp$PorterinFeature from "./FooterDownloadAppCmp.mjs";

var styles = FooterModuleScss;

function links_cmp_generator(class_nameOpt, content) {
  var class_name = class_nameOpt !== undefined ? class_nameOpt : "";
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  return React.createElement("div", {
              className: class_name
            }, React.createElement("div", {
                  className: styles.title
                }, content.title), React.createElement("div", {
                  className: styles.list
                }, Belt_Array.map(content.links, (function (footer_link) {
                        return React.createElement(Link, {
                                    href: footer_link.link + citySelectedContext.query_params,
                                    prefetch: false,
                                    children: React.createElement("div", {
                                          className: styles["list-item"],
                                          onClick: (function (param) {
                                              PublishEventsHelper$PorterinFeature.publishEvents(PageviewStore$PorterinFeature.ga_footer_event_prefix, HomeStoreEn$PorterinFeature.ga_footer_specific_link_action + (
                                                    footer_link.title === "Driver Partner Terms & Conditions" ? "Driver Partner T&C" : footer_link.title
                                                  ), footer_link.title);
                                            })
                                        }, footer_link.title),
                                    target: "_parent",
                                    key: footer_link.title
                                  });
                      }))));
}

function social_media_links_cmp(logo, links) {
  return Belt_Array.map(links, (function (link) {
                return React.createElement("a", {
                            key: link.label,
                            className: (styles[link.label]),
                            href: link.link,
                            rel: "noreferrer",
                            target: "_blank"
                          });
              }));
}

function legal_details_cmp(param) {
  var details = [
    [
      "CIN",
      FooterConfig$PorterinFeature.cnn
    ],
    [
      "Email",
      FooterConfig$PorterinFeature.email
    ],
    [
      "Phone",
      FooterConfig$PorterinFeature.phone
    ]
  ];
  return Belt_Array.map(details, (function (param) {
                var label = param[0];
                return React.createElement("div", {
                            key: label,
                            className: styles.info
                          }, React.createElement("span", {
                                className: styles["legal-info-label"]
                              }, "" + label + ": "), "" + param[1] + "");
              }));
}

function service_links_section(footer_data) {
  if (footer_data !== undefined) {
    return Belt_Array.map(footer_data.service_links_list, (function (serviceLinks) {
                  return links_cmp_generator(styles["services-links"], {
                              title: serviceLinks.title,
                              links: Belt_Array.map(serviceLinks.link_label_pairs, (function (pair) {
                                      return FooterLinksMapper$PorterinFeature.footer_link_mapper(pair.label, pair.link);
                                    }))
                            });
                }));
  } else {
    return React.createElement("div", undefined);
  }
}

function FooterCmp(Props) {
  var footer_data = Props.footer_data;
  var has_fare_estimate_button = Props.has_fare_estimate_button;
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 1024px)");
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var router = Router.useRouter();
  var footerClasses = has_fare_estimate_button ? "" + styles["footer-container"] + " " + styles["with-extra-padding"] + "" : styles["footer-container"];
  var match$1 = router.locale;
  var tmp;
  switch (match$1) {
    case "bn-BD" :
        tmp = FooterConfig$PorterinFeature.follow_us_bd;
        break;
    case "tr-TR" :
        tmp = FooterConfig$PorterinFeature.follow_us_tr;
        break;
    default:
      tmp = FooterConfig$PorterinFeature.follow_us;
  }
  var tmp$1;
  if (footer_data !== undefined) {
    var match$2 = footer_data.download_app_qr.path.length;
    if (match$2 !== 0) {
      var match$3 = router.locale;
      var tmp$2;
      switch (match$3) {
        case "bn-BD" :
            tmp$2 = FooterConfig$PorterinFeature.download_app_bd;
            break;
        case "tr-TR" :
            tmp$2 = FooterConfig$PorterinFeature.download_app_tr;
            break;
        default:
          tmp$2 = FooterConfig$PorterinFeature.download_app;
      }
      var match$4 = router.locale;
      var tmp$3;
      switch (match$4) {
        case "bn-BD" :
            tmp$3 = FooterConfig$PorterinFeature.scan_qr_code_to_download_bd;
            break;
        case "tr-TR" :
            tmp$3 = FooterConfig$PorterinFeature.scan_qr_code_to_download_tr;
            break;
        default:
          tmp$3 = FooterConfig$PorterinFeature.scan_qr_code_to_download;
      }
      tmp$1 = React.createElement("div", {
            className: styles["download-app-container"]
          }, React.createElement("div", {
                className: styles["dotted-divider"]
              }), React.createElement("div", {
                className: styles["footer-rating-download"]
              }, React.createElement(NextImage$PorterinFeature.make, {
                    src: FooterConfig$PorterinFeature.porter_rating,
                    height: 40.0,
                    width: 40.0,
                    quality: 100.0,
                    alt: DownloadAppStore$PorterinFeature.download_section.icon.alt_text
                  }), React.createElement("div", undefined, React.createElement("div", {
                        className: styles["footer-brand-heading"]
                      }, tmp$2), React.createElement("div", {
                        className: styles["footer-download-app-sub-text"]
                      }, tmp$3))), React.createElement("div", {
                className: styles["download-app-desktop-container"]
              }, React.createElement(FooterDownloadAppCmp$PorterinFeature.make, {
                    styles: styles,
                    isDesktop: isDesktop,
                    footer_data: footer_data
                  })));
    } else {
      tmp$1 = null;
    }
  } else {
    tmp$1 = null;
  }
  var match$5 = router.locale;
  var tmp$4;
  switch (match$5) {
    case "bn-BD" :
        tmp$4 = FooterConfig$PorterinFeature.follow_us_bd;
        break;
    case "tr-TR" :
        tmp$4 = FooterConfig$PorterinFeature.follow_us_tr;
        break;
    default:
      tmp$4 = FooterConfig$PorterinFeature.follow_us;
  }
  return React.createElement("footer", {
              className: footerClasses
            }, React.createElement("div", {
                  className: styles["footer-content-wrapper"]
                }, React.createElement("div", {
                      className: styles["company-info"]
                    }, React.createElement("div", {
                          className: styles["footer-brand-section"]
                        }, React.createElement("a", {
                              href: Config$PorterinUtils.oms_url + match.query_params
                            }, footer_data !== undefined ? React.createElement(NextImage$PorterinFeature.make, {
                                    src: footer_data.logo.path,
                                    height: 25.0,
                                    width: 152.5,
                                    quality: 75.0,
                                    alt: "Porter Logo"
                                  }) : React.createElement("div", undefined)), React.createElement("div", {
                              className: styles["download-app-mobile-container"]
                            }, React.createElement(FooterDownloadAppCmp$PorterinFeature.make, {
                                  styles: styles,
                                  isDesktop: isDesktop,
                                  footer_data: footer_data
                                })), React.createElement("div", {
                              className: styles["dotted-divider"]
                            }), React.createElement("div", {
                              className: styles["footer-tertiary"]
                            }, React.createElement("div", {
                                  className: styles["social-media-container"]
                                }, React.createElement("div", {
                                      className: styles["footer-brand-heading"]
                                    }, tmp), React.createElement("div", {
                                      className: styles["social-media"]
                                    }, footer_data !== undefined ? social_media_links_cmp(footer_data.social_links.logo, footer_data.social_links.social_media_links) : React.createElement("div", undefined))), tmp$1)), React.createElement("div", {
                          className: styles["footer-features"]
                        }, React.createElement("div", {
                              className: styles["footer-primary"]
                            }, service_links_section(footer_data)), React.createElement("div", {
                              className: styles["footer-secondary"]
                            }, footer_data !== undefined ? links_cmp_generator(styles["cities-truck-links"], {
                                    title: footer_data.city_links_list.title,
                                    links: Belt_Array.map(footer_data.city_links_list.link_label_pairs, (function (pair) {
                                            return FooterLinksMapper$PorterinFeature.footer_link_mapper(pair.label, pair.link);
                                          }))
                                  }) : React.createElement("div", undefined)))), React.createElement("div", {
                      className: styles["footer-legal-info"]
                    }, React.createElement("div", {
                          className: styles["copyright-wrapper"]
                        }, React.createElement("div", {
                              className: styles.info
                            }, footer_data !== undefined ? React.createElement(ReactMarkdown, {
                                    children: footer_data.company_info
                                  }) : FooterConfig$PorterinFeature.copyright_info))), React.createElement("div", {
                      className: styles["social-media-mobile-container"]
                    }, React.createElement("div", {
                          className: styles["social-media-container"]
                        }, React.createElement("div", {
                              className: styles["footer-brand-heading"]
                            }, tmp$4), React.createElement("div", {
                              className: styles["social-media"]
                            }, footer_data !== undefined ? social_media_links_cmp(footer_data.social_links.logo, footer_data.social_links.social_media_links) : React.createElement("div", undefined))))));
}

var Link$1;

var make = FooterCmp;

export {
  styles ,
  Link$1 as Link,
  links_cmp_generator ,
  social_media_links_cmp ,
  legal_details_cmp ,
  service_links_section ,
  make ,
}
/* styles Not a pure module */
